import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import { Translate } from "react-localize-redux";
import { Loader } from "../../components/index";
import { v4 as uuidv4 } from "uuid";
import logger from "../../utils/logger";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
class CodeValidation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation_code: "",
      message: "",
      cssclass: "success",
      isLoading: false,
    };
  }

  onChange = (e) => {
    let val = e.target.value;
    console.log("input val: ", val);

    if (!val) {
      console.log("empty input");
      this.setState({
        validation_code: "",
        message: <Translate id="content.voucher-not-valid" />,
      });
      return;
    }

    for (let i in val) {
      if (val[i] !== "-" && /[a-zA-Z0-9]/.test(val[i]) === false) return;
    }

    this.setState({
      validation_code: e.target.value,
    });
  };

  onValidateClick = async () => {
    // Prevent multiple clicks while loading
    if (this.state.isLoading) {
      return;
    }

    if (!this.props.auth.isAuthenticated()) {
      if (this.props.history) {
        this.props.history.push("/login");
      } else {
        window.location.href = "/login";
      }
      return;
    }
    if (!this.state.validation_code) {
      console.log("empty input");
      toast.error(<Translate id="content.voucher-empty" />);
      this.setState({
        cssclass: "status-error",
        message: <Translate id="content.voucher-empty" />,
      });
      return;
    }
    const orderNumber = uuidv4();
    const authData = this.props.auth.authData;
    let phone, email;

    if (authData) {
      if (authData.phone?.number) {
        phone = authData.phone.number;
      } else if (authData.username) {
        email = authData.username;
      }
    }

    let subscriberName = phone || email || "unknown";

    if (subscriberName === "unknown") {
      let authInfo = await this.props.auth.getAuthData();
      if (authInfo.phone?.number) {
        phone = authInfo.phone.number;
      } else if (authInfo.username) {
        email = authInfo.username;
      }
      subscriberName = phone || email || "unknown";
    }

    this.setState({ isLoading: true });
    await logger.log("info", "Voucher code validation started", {}, "", {
      currentProcess: "created",
      paymentType: "voucher",
      subscriberName: subscriberName,
      tgUserId: this.props.auth.authData.sub,
      // packageName: this.state.validation_code,
      // purchasePrice: 0,
      orderNumber: orderNumber,
    });
    console.log("writed log for voucher validation");
    axios
      .post(
        `${process.env.REACT_APP_SERVICES_API_BASE}/users/redeemvoucher?code=${this.state.validation_code}`,
        null,
        {
          headers: {
            StoreId: `${process.env.REACT_APP_STOREID}`,
            Authorization: `Bearer ${this.props.auth.authData.access_token}`,
          },
        },
      )
      .then(async (resp) => {
        toast.success(<Translate id="content.voucher-valid" />);
        this.setState({
          message: <Translate id="content.voucher-valid" />,
          cssclass: "status-success",
          isLoading: false,
        });

        await logger.log("info", "Voucher code validated", {}, JSON.stringify(resp.data), {
          currentProcess: "purchased",
          paymentType: "voucher",
          activeFrom: new Date().toISOString(),
          activeTo: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000).toISOString(),
          subscriberName: subscriberName,
          orderNumber: orderNumber,
        });
        console.log("writed log for voucher purchased");

        await logger.log("info", "Voucher code activated", {}, JSON.stringify(resp.data), {
          currentProcess: "activated",
          tgRequest: this.state.validation_code,
          tgResponse: resp.data,
          orderNumber: orderNumber,
        });
        axios.post(`https://amsys.sonsy.mn/amsys/api/sonsy-coupon`, {
          msisdn: subscriberName,
          couponcode: this.state.validation_code,
        });
        console.log("writed log for voucher activated");
        this.props.onValidate();
      })
      .catch(async (err) => {
        // await new Promise(resolve => setTimeout(resolve, 1000));
        toast.error(<Translate id="content.voucher-not-valid" />);
        this.setState({
          message: <Translate id="content.voucher-not-valid" />,
          cssclass: "status-error",
          isLoading: false,
        });
        await logger.log(
          "error",
          "Voucher code failed",
          {},
          JSON.stringify(err.response ? err.response.data : err),
          {
            currentProcess: "error",
            paymentType: "voucher",
            subscriberName: subscriberName,
            tgRequest: this.state.validation_code,
            tgResponse: err.response ? err.response.data : err,
            orderNumber: orderNumber,
          },
        );
      });
  };

  render() {
    return (
      <div className="plan-desc-container wow fadeInUp">
        <div className="justify-content-center align-self-center voucher">
          <h3 className="u-no-margin u-no-margin-bottom mb-0">
            <Translate id="title.redeem-voucher" />
          </h3>
          <p className="u-no-margin-top mb-3 mt-2">
            <Translate id="content.redeem-voucher" />
          </p>

          <Row>
            <Col xs="12">
              <div className={this.state.cssclass}>{this.state.message}</div>
            </Col>

            <Col sm="12" md="7" lg="7">
              <Translate>
                {({ translate }) => (
                  <input
                    type="text"
                    className="redeem-input"
                    name="validation_code"
                    required
                    value={this.state.validation_code}
                    onChange={this.onChange}
                    placeholder={translate("content.enter-code")}
                    maxLength="20"
                  />
                )}
              </Translate>
            </Col>

            <Col sm="12" md="5" lg="5">
              {this.state.isLoading ? (
                <Loader />
              ) : (
                <button className="validate-btn" onClick={this.onValidateClick}>
                  <Translate id="button.validate" />
                </button>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default CodeValidation;
